/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Storepage2Inputs */

const id_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Toko`)
};

const ms_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Kedai`)
};

const da_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiksside`)
};

const de_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store-Seite`)
};

const en_us2_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store Page`)
};

const es_es2_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de la tienda`)
};

const es_mx2_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de la tienda`)
};

const fil_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pahina ng Tindahan`)
};

const fr_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page de la boutique`)
};

const it_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina negozio`)
};

const hu_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolt oldal`)
};

const nl_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winkelpagina`)
};

const no_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikkside`)
};

const pl_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona sklepu`)
};

const pt_br2_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store Page`)
};

const pt_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página da loja`)
};

const ro_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina magazin`)
};

const fi_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauppasivu`)
};

const sv_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikssida`)
};

const vi_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang cửa hàng`)
};

const tr_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza Sayfası`)
};

const cs_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stránka obchodu`)
};

const bg_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница на магазина`)
};

const ru_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница магазина`)
};

const uk_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сторінка магазину`)
};

const ar_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صفحة المتجر`)
};

const hi_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोर पेज`)
};

const th_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าร้านค้า`)
};

const ja_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアページ`)
};

const zh_cn2_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store Page`)
};

const zh_hant1_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store Page`)
};

const ko_components_sandboxshell_storepage2 = /** @type {(inputs: Components_Sandboxshell_Storepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store Page`)
};

/**
* | output |
* | --- |
* | "Store Page" |
*
* @param {Components_Sandboxshell_Storepage2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_storepage2 = /** @type {((inputs?: Components_Sandboxshell_Storepage2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Storepage2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_storepage2(inputs)
	if (locale === "ms") return ms_components_sandboxshell_storepage2(inputs)
	if (locale === "da") return da_components_sandboxshell_storepage2(inputs)
	if (locale === "de") return de_components_sandboxshell_storepage2(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_storepage2(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_storepage2(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_storepage2(inputs)
	if (locale === "fil") return fil_components_sandboxshell_storepage2(inputs)
	if (locale === "fr") return fr_components_sandboxshell_storepage2(inputs)
	if (locale === "it") return it_components_sandboxshell_storepage2(inputs)
	if (locale === "hu") return hu_components_sandboxshell_storepage2(inputs)
	if (locale === "nl") return nl_components_sandboxshell_storepage2(inputs)
	if (locale === "no") return no_components_sandboxshell_storepage2(inputs)
	if (locale === "pl") return pl_components_sandboxshell_storepage2(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_storepage2(inputs)
	if (locale === "pt") return pt_components_sandboxshell_storepage2(inputs)
	if (locale === "ro") return ro_components_sandboxshell_storepage2(inputs)
	if (locale === "fi") return fi_components_sandboxshell_storepage2(inputs)
	if (locale === "sv") return sv_components_sandboxshell_storepage2(inputs)
	if (locale === "vi") return vi_components_sandboxshell_storepage2(inputs)
	if (locale === "tr") return tr_components_sandboxshell_storepage2(inputs)
	if (locale === "cs") return cs_components_sandboxshell_storepage2(inputs)
	if (locale === "bg") return bg_components_sandboxshell_storepage2(inputs)
	if (locale === "ru") return ru_components_sandboxshell_storepage2(inputs)
	if (locale === "uk") return uk_components_sandboxshell_storepage2(inputs)
	if (locale === "ar") return ar_components_sandboxshell_storepage2(inputs)
	if (locale === "hi") return hi_components_sandboxshell_storepage2(inputs)
	if (locale === "th") return th_components_sandboxshell_storepage2(inputs)
	if (locale === "ja") return ja_components_sandboxshell_storepage2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_storepage2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_storepage2(inputs)
	return ko_components_sandboxshell_storepage2(inputs)
});
export { components_sandboxshell_storepage2 as "components.sandboxShell.storePage" }